import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Icon, Text, Img } from '../../Atoms';
import { Input, Modal } from '../../Molecules';
import {
  SettingOrganism,
  ChangeSettingDetailsOraganism
} from '../../Organisms';
import HappyBunchChatting from '../../assets/img/Happy-Bunch-Chatting.png';
import { ConfirmPasswordModal, ModalConfirmDelete } from '../../Modals';
function TemplateSetting(props) {
  return (
    <div className="template-document template-send-document template-scroll">
      <div className="container-title-send-doc">
        {props.state.step !== 1 && (
          <Icon
            icon="SortTop"
            size="20px"
            className="icon-return"
            onClick={() => props.onReturn()}
          />
        )}
        <Text
          text="Mon compte"
          className={
            props.state.step == 1
              ? 'title-document'
              : 'title-document title-web-hidden'
          }
        />
        {props.state.step != 1 && (
          <Text
            text="Mon compte"
            className="title-send-document title-mobile-hidden"
          />
        )}
      </div>
      <div className="content-template-setting">
        {props.state.step === 1 && (
          <div className="container-change-password">
            <Text text="Mon compte" className="title-change-password" />
            <Row>
              <Col xs={12} md={{ span: 5, order: 1 }}>
                <div style={{ cursor: 'pointer' }} onClick={props.onSubmit}>
                  <SettingOrganism
                    title="Mot de passe"
                    description="Modifier votre mot de passe"
                    icon={props.state.updatePassword ? 'Sort' : 'SortTop'}
                    iconClassName={
                      props.state.updatePassword
                        ? 'remboursement-desktop-organism-description-icon'
                        : 'icon-next-step'
                    }
                    size={19}
                    password={true}
                    onClick={() => props.onSubmit()}
                  />
                </div>
              </Col>

              <Col xs={12} md={{ span: 5, order: 1 }}>
                <SettingOrganism
                  title="Supprimer mon compte"
                  description="Attention, la suppression de votre compte n'entraine pas la résiliation de votre contrat."
                  icon={props.state.deleteAccount ? 'Sort' : 'SortTop'}
                  iconClassName={
                    props.state.deleteAccount
                      ? 'remboursement-desktop-organism-description-icon'
                      : 'icon-next-step'
                  }
                  size={19}
                  password={true}
                  onClick={() => props.validateDeleteAccount()}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
      {props.state.show && (
        <ConfirmPasswordModal
          img={HappyBunchChatting}
          show={props.state.show}
          onHide={() => props.onHide('password')}
          modalStep={props.state.modalStep}
          title="Validation du changement de mot de passe"
          firstText={
            'Nous venons d’envoyer un code par email à ' +
            props.state.email.email
          }
          secondText="Veuillez le renseigner ci-dessous pour confirmer le changement de mot de passe : "
          onConfirmCode={() => props.onConfirmCode('password')}
          onCancel={() => props.onHide('password')}
          successText="Votre mot de passe a été modifié."
          code={props.code}
          onChange={props.changeCode}
          passwordErrorMsg={props.passwordErrorMsg}
        />
      )}
      {props.state.showMail && (
        <ConfirmPasswordModal
          img={HappyBunchChatting}
          show={props.state.showMail}
          onHide={() => props.onHide('mail')}
          modalStep={props.state.modalStep}
          title="Validation du changement de votre email"
          firstText={
            'Nous venons d’envoyer un code par email à ' +
            props.state.email.email
          }
          secondText="Veuillez le renseigner ci-dessous pour confirmer le changement de mot de passe : "
          onConfirmCode={() => props.onConfirmCode('mail')}
          onCancel={() => props.onHide('mail')}
          successText="Votre mot de passe a été modifié."
          code={props.code}
          onChange={props.changeCode}
        />
      )}
      {props.state.showDeleteConfirm && (
        <>
          <ModalConfirmDelete
            img={HappyBunchChatting}
            show={props.state.showDeleteConfirm}
            onHide={() => props.onHide('mail')}
            modalStep={props.state.modalStep}
            title="Supprimer mon compte"
            onConfirmDeleteInModal={() => props.onConfirmDeleteInModal()}
            onCancel={() => props.onClickCancelDeleteAccount()}
            successText="Votre mot de passe a été modifié."
            code={props.code}
            onChange={props.changeCode}
            onConfirmCodeDelete={props.onConfirmCodeDelete}
            onCloseDeleteModal={props.onCloseDeleteModal}
            verificationErrorMsg={props.state.verificationErrorMsg}
            sendCodeAgain={props.sendCodeAgain}
          />
        </>
      )}
    </div>
  );
}
export default TemplateSetting;
